import * as React from "react";
import { useRef, useEffect } from "react";
import { Text, Image, RichText, Link } from "@sitecore-jss/sitecore-jss-react";
import { useState, useLayoutEffect } from "react";
import { withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import { GenerateIdForGA } from "../../types/helpers";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { scaleImage } from "../../utils/scaleImage";
import { checkDeviceType } from "../../utils/checkDeviceType";
import "./index.scss";
import { returnSvgImage } from "../../utils/svgImage";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import { forEach } from "jszip";
import Select from "react-select";
import  HeaderMenuModule  from "./../../react-only-components/HeaderMenuModule/index";
import { changeWishlistIconColor } from "./../../utils/WishlistApis";
import useWishlistStore from './../../store/wishlistStore';

const GlobalMenuModule = (props) => {
  const leftNavigationList = props?.fields?.LeftNavigationList?.fields?.Links ?? [];
  const rightNavigationList = props?.fields?.RightNavigationList?.fields?.Links ?? [];
  const enablePrivateArea = props?.fields?.UsePersonalisedButtons?.value;
  const isUserAuthenticated = props?.fields?.UserAuthenticated;
  const rightUsersButtons = props?.fields?.RightUserButtons?.fields?.Links ?? [];
  let windowScrollY;
  if (typeof window !== "undefined") {
    windowScrollY = window.scrollY;
  }
  const [active, setActive] = useState();
  const [actualLanguage, setActualLanguage] = useState(
    props?.sitecoreContext?.language?.toUpperCase()
      ? props.sitecoreContext.language.toUpperCase()
      : "EN"
  );
  const [innerInternalWidth, setInnerInternalWidth] = useState(0);
  const [deviceType, setDeviceType] = useState("");
  const [windowWidth, setWindowWidth] = useState(null);
  const [prevScrollPos, setPrevScrollPos] = useState(windowScrollY);
  const [createdLanguageSelect, setCreatedLanguageSelect] = useState(false);
  const [marginTop, setMarginTop] = useState(0);
  const isRtl = props?.sitecoreContext?.ContextExtensions?.isRTL;
  const globalMenuRef = useRef(null);
  const { items: wishlistItems } = useWishlistStore();

  const { t } = useTranslation();

  useLayoutEffect(() => {
    if (!globalMenuRef.current) return;

    const node = globalMenuRef.current;
    const compute = () => setMarginTop(node.getBoundingClientRect().height);
    compute();

    const ro = new ResizeObserver(compute);
    ro.observe(node);

    return () => ro.disconnect();
  }, []);

  function changeLanguage(url) {
    window.location.assign(url);
  }

  function closeAllSelect(elmnt) {
    /* A function that will close all select boxes in the document,
      except the current select box: */
    var x,
      y,
      i,
      xl,
      yl,
      arrNo = [];
    x = document.getElementsByClassName("select-items");
    y = document.getElementsByClassName("select-selected");
    xl = x.length;
    yl = y.length;
    for (i = 0; i < yl; i++) {
      if (elmnt == y[i]) {
        arrNo.push(i);
      } else {
        y[i].classList.remove("select-arrow-active");
      }
    }
    for (i = 0; i < xl; i++) {
      if (arrNo.indexOf(i)) {
        x[i].classList.add("select-hide");
      }
    }
  }

  const closeHeaderMenu = () => {
    setSelectedRightUserButton(null);
    setShowHeaderMenu(false);
  };

  const LanguageSelector = ({
    languages,
    selectedLanguage,
    onChange,
    id,
    icon,
    useLinksFromSettings,
  }) => {
    const options = languages?.map((lang) => ({
      value:
        useLinksFromSettings &&
        props &&
        props?.sitecoreContext &&
        props?.sitecoreContext?.ContextExtensions?.changeLanguages &&
        props?.sitecoreContext?.ContextExtensions?.changeLanguages.length > 0
          ? props.sitecoreContext.ContextExtensions.changeLanguages.find(
              (elem) =>
                elem.language.toUpperCase() == lang.Language.value.toUpperCase()
            )?.languageLink
          : lang.Link.value.href,
      name: lang.Language.value.toUpperCase(),
      label: lang.Link.value.text,
    }));

    return (
      <>
        {icon}
        <Select
          classNamePrefix="language"
          value={options.find((option) => option.name === selectedLanguage)}
          onChange={onChange}
          options={options}
          className="styled-select"
          id={id}
        />
      </>
    );
  };

  function createSelectLanguage(links, item, useLinksFromSettings) {
    if (typeof document != "undefined" && !createdLanguageSelect) {
      const icon = (
        <span
          className="icon"
          dangerouslySetInnerHTML={{
            __html: item?.fields?.Iconcss?.value
              ? returnSvgImage(
                  item?.fields?.Icon?.value,
                  item?.fields?.Iconcss?.value
                )
              : item?.fields?.Icon?.value?.svgCode,
          }}
        />
      );

      const renderLanguageSelector = (
        anchorElement,
        containerClass,
        selectId,
        icon,
        useLinksFromSettings
      ) => {
        if (anchorElement) {
          const aDiv = document.createElement("div");

          aDiv.setAttribute("class", containerClass);
          anchorElement.appendChild(aDiv);

          let languages = [];

          links.forEach((link) => {
            languages.push(link.fields);
          });

          ReactDOM.render(
            React.createElement(LanguageSelector, {
              languages: languages,
              selectedLanguage: actualLanguage,
              onChange: (option) => {
                changeLanguage(option.value);
              },
              id: selectId,
              icon: icon,
              useLinksFromSettings: useLinksFromSettings,
            }),
            aDiv
          );
          document.addEventListener("click", closeAllSelect);
          setCreatedLanguageSelect(true);
        }
      };
      // DESKTOP
      const desktopMenu = document.getElementsByClassName("global-menu-module")[0];
      const desktopAnchorElement =
        desktopMenu?.getElementsByClassName("left")?.[0]?.childNodes?.[0]?.childNodes?.[0];

        if (desktopAnchorElement) {
          renderLanguageSelector(
            desktopAnchorElement,
            "styled-select-container",
            "changeLanguageSelect",
            icon,
            useLinksFromSettings
          );
        }

      // MOBILE
      const mobileMenu = document.getElementsByClassName("global-menu-links__mobile")[0];
      const mobileAnchorElement =
        mobileMenu?.getElementsByClassName("left")?.[0]?.childNodes?.[0]?.childNodes?.[0];

        if(mobileAnchorElement) {
      renderLanguageSelector(
        mobileAnchorElement,
        "styled-select-container-mobile",
        "changeLanguageSelectMobile",
        icon,
        useLinksFromSettings
      );
    }
    }
  }

  const localstorageService = () =>
    typeof localStorage !== "undefined"
      ? localStorage
      : {
          clear: () => undefined,
          getItem: () => undefined,
          key: () => null,
          removeItem: () => undefined,
          setItem: () => undefined,
        };

  useEffect(() => {
    if (typeof window !== "undefined" && typeof navigator !== "undefined") {
      setDeviceType(checkDeviceType(navigator));
      setWindowWidth(window.innerWidth);
    }
    if (typeof window != "undefined") {
      setInnerInternalWidth(window.innerWidth);
      window.addEventListener("resize", () => {
        setInnerInternalWidth(window.innerWidth);
      });
    }   
    
    /**
     * setting handler to close the dropdown header menu when clicked outside
     */
    // if(typeof document !== "undefined") {
    //   const outsideClickHandler = (event) => {
    //     const headerMenuElement = document?.querySelector('.header-menu-container');
    //     if (headerMenuElement && !headerMenuElement?.contains(event.target as Node)) {
    //       setSelectedRightUserButton(null);
    //       setShowHeaderMenu(false);
    //     }
    //   }
    //   document.addEventListener('click', outsideClickHandler); 
    // }
  }, []);

  useEffect(() => {
    if (!createdLanguageSelect) {
      leftNavigationList.forEach((item) => {
        if (item?.fields?.isChangeLanguage?.value == true) {
          createSelectLanguage(
            item?.fields?.Links,
            item,
            item?.fields?.useLinksFromSettings?.value
          );
        }
      });
    }
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleScroll = () => {
        const currentScrollPos = window.pageYOffset || window.scrollY;
        if (currentScrollPos > prevScrollPos) {
          handleCloseMenu();
        }
        setPrevScrollPos(currentScrollPos);
      };

      window.addEventListener("scroll", handleScroll);

      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }
  }, [prevScrollPos]);



  const handleCloseMenu = () => {
    if (typeof document !== "undefined") {
      let megaMenus = document.getElementsByClassName("mega-menu active");
      if (megaMenus.length > 0) {
        Array.from(megaMenus).forEach((megaMenu) => {
          megaMenu.classList.remove("active");
        });
      }

      const links = document.querySelectorAll(".global-menu-module .link");
      links.forEach((link) => {
        if (link.classList.contains("active")) {
          link.classList.remove("active");
        }
      });
      setActive(null);
    }
  };

  let foundActive = false;
  const arrow = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 12H21"
        stroke="#14181F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 7L21 12L16 17"
        stroke="#14181F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  let language = "EN";
  if (props && props.sitecoreContext && props.sitecoreContext.language) {
    language = props.sitecoreContext.language.toUpperCase();
  }

  const activeTab = (index) => {
    if (typeof document != "undefined") {
      //if no mega menu open highlight
      if (document.getElementsByClassName("mega-menu active").length < 1) {
        setActive(index);
      }
    }
  };

  const handleMouseOut = () => {
    setActive(null);
  };

  let isScrolling = false;

  if (typeof window !== "undefined") {
    window.addEventListener("scroll", () => {
      isScrolling = true;
    });

    window.addEventListener("scroll", () => {
      isScrolling = true;
      setTimeout(() => {
        isScrolling = false;
      }, 250);
    });
  }

  const openCloseMegaMenu = (key, item, event) => {
    if (typeof document != "undefined") {
      if (
        event &&
        event.target.closest(".mega-menu") &&
        !event.target.closest("li") &&
        !isScrolling
      ) {
        return;
      }
      let megaMenus = document.getElementsByClassName("mega-menu active");
      if (megaMenus.length > 0) {
        setActive(null);
        for (let index = 0; index < megaMenus.length; index++) {
          if (megaMenus[index].id !== "mega-menu" + key) {
            megaMenus[index].classList.remove("active");
          }
        }
      }
    }

    if (
      document.getElementById("mega-menu" + key).classList.contains("active")
    ) {
      document.getElementById("mega-menu" + key).classList.remove("active");
    } else {
      setActive(item);
      document.getElementById("mega-menu" + key).classList.add("active");
    }
  };

  const getActiveClass = (index, className) =>
    active === index ? className : "";

  const isCurrentNavigation = (item, className) => {
    let yes = false;

    if (typeof window !== "undefined" && window && foundActive === false) {
      let url = (window.location.pathname + window.location.search)
        .trim()
        .toLowerCase();

      // console.log(foundActive,className, item?.fields?.Link?.value?.href.trim().toLowerCase() == url, item?.fields?.Link?.value?.href.trim().toLowerCase(),url, item);

      if (
        item?.fields?.MainButtonLink?.value?.href.trim().toLowerCase() == url
      ) {
        // console.log('FOUND:',item);
        yes = true;
        foundActive = item;
        return className;
      } else if (item?.fields?.Link?.value?.href.trim().toLowerCase() == url) {
        // console.log('FOUND ',item);
        yes = true;
        foundActive = item;
        return className;
      } else {
        item?.fields?.SubNavigationLinks?.fields?.Links.forEach((element) => {
          if (
            !yes &&
            element?.fields?.Link?.value?.href.trim().toLowerCase() == url
          ) {
            yes = true;
          }
        });
        if (!yes) {
          // console.log('not found: '+item);
          return "";
        } else {
          // console.log('found: '+item);
          foundActive = item;
          return className;
        }
      }
    } else if (foundActive === item) {
      return className;
    } else {
      return "";
    }
  };

  const [selectedRightUserButton, setSelectedRightUserButton] = useState(null);
  const [showHeaderMenu, setShowHeaderMenu] = useState(false);

  const showLoginHeaderMenu = (event, item) => {
    //stop propagatpon to prevent closing the dropdown menu
    event.stopPropagation();
    
    if(showHeaderMenu && item === selectedRightUserButton) {
      closeHeaderMenu();
    }
    else {
      setSelectedRightUserButton(item);
      setShowHeaderMenu(true);
    }
  }

 useEffect(() => {
   /**
    * If the private area is enabled and the user is authenticated,
    * then check if the current page is on the wishlist in order to change the wishlist tab icon color
    */
   if (enablePrivateArea && isUserAuthenticated) {
     const wishlistTab = rightUsersButtons.find((item) => item?.Wishlist_Button);
     const currentPageId = wishlistTab?.Wishlist_Button?.PageId

     const isCurrPageOnWishlist = wishlistItems?.some(
      (item) => item?.fields?.PageId?.value === currentPageId
    );

     changeWishlistIconColor(!!isCurrPageOnWishlist);
   }
 }, [enablePrivateArea, isUserAuthenticated, wishlistItems, rightUsersButtons]);

 useEffect(() => {
  if (!showHeaderMenu) return;
  if (typeof window === "undefined") return;

  const handleClickOutside = (event) => {
    const target = event.target as HTMLElement;

    const clickedMenuButton = target?.closest(".menu-button");
    const clickedInsideDropdown = target?.closest(".header-menu-container");

    if (!clickedMenuButton && !clickedInsideDropdown) {
      closeHeaderMenu();
    }
  };

  const handleScrollClose = (event) => {
    const target = event.target as HTMLElement;

    const scrolledInsideDropdown = target?.closest?.(".header-menu-container");
    const scrolledMenuButton = target?.closest?.(".menu-button");

    if (!scrolledInsideDropdown && !scrolledMenuButton) {
      closeHeaderMenu();
    }
  };

  document.addEventListener("click", handleClickOutside);
  window.addEventListener("scroll", handleScrollClose, true);

  return () => {
    document.removeEventListener("click", handleClickOutside);
    window.removeEventListener("scroll", handleScrollClose, true);
  };
}, [showHeaderMenu]);


  return (
    <>
      <section className="global-menu-module" ref={globalMenuRef}>
        <div className={`global-menu-links ${isRtl ? "global-menu-rtl" : ""}`}>
          <div className="left">
            <ul>
              {leftNavigationList.map((item, i) => {
                return item?.fields?.Description ? (
                  <li
                    className={`link ${getActiveClass(
                      item,
                      "active"
                    )} `}
                    /* onMouseOver={() => {
                      activeTab(item);
                    }} */
                    key={i}
                    // onMouseOut={handleMouseOut}
                    onClick={() => openCloseMegaMenu(i, item, event)}
                  >
                    <span>{item?.fields?.Link?.value?.text}</span>
                    <span
                      className="icon"
                      dangerouslySetInnerHTML={{
                        __html: item?.fields?.Iconcss?.value
                          ? returnSvgImage(
                              item?.fields?.Icon?.value,
                              item?.fields?.Iconcss?.value
                            )
                          : item?.fields?.Icon?.value?.svgCode,
                      }}
                    />

                    <div
                      className={`mega-menu`}
                      id={"mega-menu" + i}
                      key={i}
                      onMouseLeave={handleCloseMenu}
                      style={{ marginTop: (marginTop - 1) + "px" }}
                    >
                      <div className="menu">
                        {innerInternalWidth <= 640 ||
                        innerInternalWidth < 1366 ? (
                          <div className="medium-resize cp-row">
                            <div
                              className={`col-left ${
                                item?.fields?.Image?.value?.src === undefined
                                  ? "col-12"
                                  : "col-6"
                              }`}
                            >
                              <div className="title">
                                <Text
                                  tag="h5"
                                  field={item?.fields?.["SectionTitle"]}
                                ></Text>
                                <Link
                                  field={item?.fields?.MainButtonLink}
                                  target={
                                    item?.fields?.MainButtonLink?.value?.target
                                  }
                                  className="main-button"
                                  id={GenerateIdForGA(
                                    "globalMenu",
                                    item?.fields?.MainButtonLink?.value?.text +
                                      "_mainButton"
                                  )}
                                >
                                  <span className="text">
                                    {item?.fields?.MainButtonLink?.value?.text}
                                  </span>
                                  <span className="menu-arrow">{arrow}</span>
                                </Link>
                              </div>
                              <div className="links">
                                {(item?.fields?.SubNavigationLinks?.fields?.Links ?? []).map(
                                  (el, x) => (
                                    <Link
                                      className="links-link"
                                      field={el?.fields?.Link}
                                      target={el?.fields?.Link?.value?.target}
                                      key={x}
                                      id={GenerateIdForGA(
                                        "globalMenu",
                                        el?.fields?.Link?.value?.text +
                                          "_subNavigation"
                                      )}
                                    >
                                      {item?.fields?.Image?.value?.src ===
                                      undefined ? (
                                        <LazyLoadImage
                                          src={
                                            deviceType === "mobile"
                                              ? scaleImage(
                                                  el?.fields?.["Image"]?.value
                                                    ?.src,
                                                  windowWidth,
                                                  1
                                                )
                                              : el?.fields?.["Image"]?.value
                                                  ?.src
                                          }
                                          alt={
                                            el?.fields?.["Image"]?.value?.alt
                                          }
                                          className="link-image"
                                          height={
                                            el?.fields?.["Image"]?.value?.height
                                          }
                                          width={
                                            el?.fields?.["Image"]?.value?.width
                                          }
                                        ></LazyLoadImage>
                                      ) : (
                                        ""
                                      )}
                                      <span className="links-content">
                                        <span className="link-text">
                                          {el?.fields?.Link?.value?.text}
                                        </span>
                                        <span
                                          className="menu-icon"
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              innerInternalWidth < 1136
                                                ? el?.fields?.Iconcss?.value &&
                                                  el?.fields?.["Mobile Icon"]
                                                    ?.value?.src
                                                  ? returnSvgImage(
                                                      el?.fields?.[
                                                        "Mobile Icon"
                                                      ]?.value,
                                                      el?.fields?.Iconcss?.value
                                                    )
                                                  : returnSvgImage(
                                                      el?.fields?.Icon?.value,
                                                      el?.fields?.Iconcss?.value
                                                    )
                                                : el?.fields?.Iconcss?.value
                                                ? returnSvgImage(
                                                    el?.fields?.Icon?.value,
                                                    el?.fields?.Iconcss?.value
                                                  )
                                                : el?.fields?.Icon?.value
                                                    ?.svgCode,
                                          }}
                                        />
                                      </span>
                                    </Link>
                                  )
                                )}
                              </div>
                            </div>
                            {item?.fields?.Image?.value?.src === undefined ? (
                              ""
                            ) : (
                              <div className="highlight col-6">
                                <LazyLoadImage
                                  src={
                                    deviceType === "mobile"
                                      ? scaleImage(
                                          item?.fields?.["Image"]?.value?.src,
                                          windowWidth,
                                          1
                                        )
                                      : item?.fields?.["Image"]?.value?.src
                                  }
                                  alt={item?.fields?.["Image"]?.value?.alt}
                                  height={
                                    item?.fields?.["Image"]?.value?.height
                                  }
                                  width={item?.fields?.["Image"]?.value?.width}
                                ></LazyLoadImage>
                                <div className="content">
                                  <RichText
                                    tag="p"
                                    field={item?.fields?.["Title"]}
                                    className="subtitle"
                                  ></RichText>
                                  <RichText
                                    tag="h5"
                                    field={item?.fields?.["Description"]}
                                    className="description"
                                  ></RichText>
                                  <Link
                                    field={item?.fields?.SecondaryButton}
                                    target={
                                      item?.fields?.SecondaryButton?.value
                                        ?.target
                                    }
                                    id={GenerateIdForGA(
                                      "globalMenu",
                                      item?.fields?.SecondaryButton?.value
                                        ?.href + "_secondaryButton"
                                    )}
                                  >
                                    {item?.fields?.SecondaryButton?.value?.href}
                                  </Link>
                                </div>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className="large-resize cp-row">
                            <div className="title col-3">
                              <Text
                                tag="h5"
                                field={item?.fields?.["SectionTitle"]}
                              ></Text>
                              <Link
                                field={item?.fields?.MainButtonLink}
                                target={
                                  item?.fields?.MainButtonLink?.value?.target
                                }
                                className="main-button"
                                id={GenerateIdForGA(
                                  "globalMenu",
                                  item?.fields?.MainButtonLink?.value?.text +
                                    "_mainButton"
                                )}
                              >
                                <span className="text">
                                  {item?.fields?.MainButtonLink?.value?.text}
                                </span>
                                <span className="menu-arrow">{arrow}</span>
                              </Link>
                            </div>
                            <div
                              className={`links ${
                                item?.fields?.Image?.value?.src !== undefined
                                  ? "col-6"
                                  : "col-9"
                              }`}
                            >
                              {(item?.fields?.SubNavigationLinks?.fields?.Links ?? []).map(
                                (el, x) => (
                                  <Link
                                    className="links-link"
                                    field={el?.fields?.Link}
                                    key={x}
                                    target={el?.fields?.Link?.value?.target}
                                    id={GenerateIdForGA(
                                      "globalMenu",
                                      el?.fields?.Link?.value?.text +
                                        "_subNavigation"
                                    )}
                                  >
                                    {item?.fields?.Image?.value?.src ===
                                    undefined ? (
                                      <LazyLoadImage
                                        src={
                                          deviceType === "mobile"
                                            ? scaleImage(
                                                el?.fields?.["Image"]?.value
                                                  ?.src,
                                                windowWidth,
                                                1
                                              )
                                            : el?.fields?.["Image"]?.value?.src
                                        }
                                        alt={el?.fields?.["Image"]?.value?.alt}
                                        className="link-image"
                                        height={
                                          el?.fields?.["Image"]?.value?.height
                                        }
                                        width={
                                          el?.fields?.["Image"]?.value?.width
                                        }
                                      ></LazyLoadImage>
                                    ) : (
                                      ""
                                    )}
                                    <span className="links-content">
                                      <span className="link-text">
                                        {el?.fields?.Link?.value?.text}
                                      </span>
                                      <span
                                        className="menu-icon"
                                        dangerouslySetInnerHTML={{
                                          __html: el?.fields?.Iconcss?.value
                                            ? returnSvgImage(
                                                el?.fields?.Icon?.value,
                                                el?.fields?.Iconcss?.value
                                              )
                                            : el?.fields?.Icon?.value?.svgCode,
                                        }}
                                      />
                                    </span>
                                  </Link>
                                )
                              )}
                            </div>
                            {item?.fields?.Image?.value?.src !== undefined ? (
                              <div className="highlight col-3">
                                <LazyLoadImage
                                  src={
                                    deviceType === "mobile"
                                      ? scaleImage(
                                          item?.fields?.["Image"]?.value?.src,
                                          windowWidth,
                                          1
                                        )
                                      : item?.fields?.["Image"]?.value?.src
                                  }
                                  alt={item?.fields?.["Image"]?.value?.alt}
                                  height={
                                    item?.fields?.["Image"]?.value?.height
                                  }
                                  width={item?.fields?.["Image"]?.value?.width}
                                ></LazyLoadImage>
                                <div className="content">
                                  <RichText
                                    tag="p"
                                    field={item?.fields?.["Title"]}
                                    className="subtitle"
                                  ></RichText>
                                  <RichText
                                    tag="h5"
                                    field={item?.fields?.["Description"]}
                                    className="description"
                                  ></RichText>
                                  <Link
                                    field={item?.fields?.SecondaryButton}
                                    target={
                                      item?.fields?.SecondaryButton?.value
                                        ?.target
                                    }
                                    id={GenerateIdForGA(
                                      "globalMenu",
                                      item?.fields?.SecondaryButton?.value
                                        ?.href + "_secondaryButton"
                                    )}
                                  >
                                    {item?.fields?.SecondaryButton?.value?.href}
                                  </Link>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        )}
                      </div>
                      {item?.fields?.BottomButtonlist?.fields?.Links[0] !==
                      undefined ? (
                        <div className="menu-footer">
                          {(item?.fields?.BottomButtonlist?.fields?.Links ?? []).map(
                            (el, x) => (
                              <Link
                                field={el?.fields?.Link}
                                key={x}
                                target={el?.fields?.Link?.value?.target}
                                id={GenerateIdForGA(
                                  "globalMenu",
                                  el?.fields?.Link?.value?.text +
                                    "_bottomButtonList"
                                )}
                              >
                                <span className="text">
                                  {el?.fields?.Link?.value?.text}
                                </span>
                                <span
                                  className="menu-icon"
                                  dangerouslySetInnerHTML={{
                                    __html: el?.fields?.Iconcss?.value
                                      ? returnSvgImage(
                                          el?.fields?.Icon?.value,
                                          el?.fields?.Iconcss?.value
                                        )
                                      : item?.fields?.Icon?.value?.svgCode,
                                  }}
                                />
                              </Link>
                            )
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </li>
                ) : item?.fields?.["Language Link"]?.value == true ? (
                  <li>
                    <Link
                      className={`link-simple ${item?.fields?.IsHighlighted?.value ? "link-highlighted" : ""}`}
                      field={item?.fields?.Link}
                      target={item?.fields?.Link?.value?.target}
                      aria-label="_"
                      id={GenerateIdForGA(
                        "globalMenu",
                        language + "_languageLink"
                      )}
                    >
                      <span
                        className="icon"
                        dangerouslySetInnerHTML={{
                          __html: item?.fields?.Iconcss?.value
                            ? returnSvgImage(
                                item?.fields?.Icon?.value,
                                item?.fields?.Iconcss?.value
                              )
                            : item?.fields?.Icon?.value?.svgCode,
                        }}
                      />
                      {language}
                      {item?.fields?.Link?.value?.linktype === "external" &&
                      (!item?.fields?.Icon ||
                        !item?.fields?.Icon?.value ||
                        item?.fields?.Icon?.value?.svgCode === "") ? (
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          
                        >
                          <path
                            d="M6 9L12 3"
                            stroke="#9E9E9E"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M7 3H12V8"
                            stroke="#9E9E9E"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      ) : (
                        ""
                      )}
                    </Link>
                  </li>
                ) : (
                  <li
                    className={`  ${getActiveClass(
                      item,
                      "active"
                    )} `}
                  >
                    <Link
                      className={`link-simple ${item?.fields?.IsHighlighted?.value ? "link-highlighted" : ""}`}
                      target={item?.fields?.Link?.value?.target}
                      field={item?.fields?.Link}
                      aria-label="_"
                      id={GenerateIdForGA(
                        "globalMenu",
                        item?.fields?.Link?.value?.text + "_link"
                      )}
                    >
                      <span
                        className="icon"
                        dangerouslySetInnerHTML={{
                          __html: item?.fields?.Iconcss?.value
                            ? returnSvgImage(
                                item?.fields?.Icon?.value,
                                item?.fields?.Iconcss?.value
                              )
                            : item?.fields?.Icon?.value?.svgCode,
                        }}
                      />
                      {item?.fields?.Link?.value?.text}
                      {item?.fields?.Link?.value?.linktype === "external" &&
                      (!item?.fields?.Icon ||
                        !item?.fields?.Icon?.value ||
                        item?.fields?.Icon?.value?.svgCode === "") ? (
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className={isRtl ? "icon-rtl" : ""}

                        >
                          <path
                            d="M6 9L12 3"
                            stroke="#9E9E9E"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M7 3H12V8"
                            stroke="#9E9E9E"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      ) : (
                        ""
                      )}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="right">
            <ul>
              {rightNavigationList.map((item, i) => (
                <li
                  key={i}
                  className={`  ${getActiveClass(
                    item,
                    "active"
                  )} `}
                >
                  <Link
                    className={`link-simple ${item?.fields?.IsHighlighted?.value ? "link-highlighted" : ""} ${item?.fields?.ForceNotWhite?.value ? "link-blue-icon" : ""}`}
                    target={item?.fields?.Link?.value?.target}
                    field={item?.fields?.Link}
                    aria-label="_"
                    id={GenerateIdForGA(
                      "globalMenu",
                      item?.fields?.Link?.value?.text + "_link"
                    )}
                  >
                    <span
                      className="icon"
                      dangerouslySetInnerHTML={{
                        __html: item?.fields?.Iconcss?.value
                          ? returnSvgImage(
                              item?.fields?.Icon?.value,
                              item?.fields?.Iconcss?.value
                            )
                          : item?.fields?.Icon?.value?.svgCode,
                      }}
                    />
                    <span className="right-icon_text">
                      {item?.fields?.Link?.value?.text}
                    </span>
                    {item?.fields?.Link?.value?.linktype !== "external" &&
                    item?.fields?.Icon?.value?.svgCode === "" ? (
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className={isRtl ? "icon-rtl" : ""}
                      >
                        <path
                          d="M6 9L12 3"
                          stroke="#9E9E9E"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M7 3H12V8"
                          stroke="#9E9E9E"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    ) : (
                      ""
                    )}
                  </Link>
                </li>
              ))}
              {enablePrivateArea ? (
                isUserAuthenticated ? (
                  <>
                    <li className="divider"/>
                    {rightUsersButtons.map((item, i) => (
                      <li
                        key={i}
                        className={
                          `menu-button ${item === selectedRightUserButton ? "active" : ""}` + 
                          `${item?.Wishlist_Button ? " wishlist-tab-icon" : ""}`
                        }
                        onClick={(e) => showLoginHeaderMenu(e, item)}
                      >
                        <span
                          className="icon"
                          dangerouslySetInnerHTML={{
                            __html: item?.fields?.Iconcss?.value
                              ? returnSvgImage(
                                  item?.fields?.Icon?.value,
                                  item?.fields?.Iconcss?.value
                                )
                              : item?.fields?.Icon?.value?.svgCode,
                          }}
                        />
                      </li>
                    ))}
                    <HeaderMenuModule 
                      dropDownOption={innerInternalWidth > 1136} 
                      selectedButton={selectedRightUserButton}
                      userFullName={props?.fields?.UserFullName}
                      userEmail={props?.fields?.UserEmail}
                    />
                  </>
                  ) : (
                    <li>
                      <form
                        action={props?.fields?.RightAnonButtons?.LoginUrl}
                        method="POST"
                        className="global-menu-login-form"
                      >
                        <button className="login-btn" type="submit">
                          <span
                            className="icon"
                            dangerouslySetInnerHTML={{
                              __html: props?.fields?.RightAnonButtons?.fields?.Icon?.value?.svgCode,
                            }}
                          />
                          {props?.fields?.RightAnonButtons?.fields?.Label?.value}
                        </button>
                      </form>
                    </li>
                  )
                ) : null
              }
            </ul>
          </div>
        </div>
      </section>
    </>
  );
};

export default withSitecoreContext()(GlobalMenuModule);
